import ApiService from 'app/services/ApiService';
//Filter Training
export const GET_TRAINING_REQUEST = 'GET_TRAINING_REQUEST';
export const GET_TRAINING_SUCCESS = 'GET_TRAINING_SUCCESS';
export const GET_TRAINING_FAILURE = 'GET_TRAINING_FAILURE';
//Filter SPECIALTYORSYSTEM
export const GET_SPECIALTYORSYSTEM_REQUEST = 'GET_SPECIALTYORSYSTEM_REQUEST';
export const GET_SPECIALTYORSYSTEM_SUCCESS = 'GET_SPECIALTYORSYSTEM_SUCCESS';
export const GET_SPECIALTYORSYSTEM_FAILURE = 'GET_SPECIALTYORSYSTEM_FAILURE';
//Filter COMMUNICATIONPROGRAM
export const GET_COMMUNICATIONPROGRAM_REQUEST = 'GET_COMMUNICATIONPROGRAM_REQUEST';
export const GET_COMMUNICATIONPROGRAM_SUCCESS = 'GET_COMMUNICATIONPROGRAM_SUCCESS';
export const GET_COMMUNICATIONPROGRAM_FAILURE = 'GET_COMMUNICATIONPROGRAM_FAILURE';
//Filter PROCEDUREMATERIAL
export const GET_PROCEDUREMATERIAL_REQUEST = 'GET_PROCEDUREMATERIAL_REQUEST';
export const GET_PROCEDUREMATERIAL_SUCCESS = 'GET_PROCEDUREMATERIAL_SUCCESS';
export const GET_PROCEDUREMATERIAL_FAILURE = 'GET_PROCEDUREMATERIAL_FAILURE';
//grid HISTORYCOMPAIGN
export const FETCH_HISTORYCOMPAIGN_REQUEST = 'FETCH_HISTORYCOMPAIGN_REQUEST';
export const FETCH_HISTORYCOMPAIGN_SUCCESS = 'FETCH_HISTORYCOMPAIGN_SUCCESS';
export const FETCH_HISTORYCOMPAIGN_FAILURE = 'FETCH_HISTORYCOMPAIGN_FAILURE';

//Export History
export const EXPORT_HISTORYCOMPAIGN_REQUEST = 'EXPORT_HISTORYCOMPAIGN_REQUEST';
export const EXPORT_HISTORYCOMPAIGN_SUCCESS = 'EXPORT_HISTORYCOMPAIGN_SUCCESS';
export const EXPORT_HISTORYCOMPAIGN_FAILURE = 'EXPORT_HISTORYCOMPAIGN_FAILURE';


export const CLEAR_REDUCER = 'CLEAR_REDUCER';
export const CLEAR_HISTORYCAMPAING = 'CLEAR_HISTORYCAMPAING';
export const SAVE_FILTER = 'SAVE_FILTER';
export const SAVE_PAGINATION = 'SAVE_PAGINATION';


export const getTrainingHC = (param) => dispatch => {
    dispatch({ type: GET_TRAINING_REQUEST });
    ApiService.getTrainingHC(param).then(
        response => {
            dispatch({
                type: GET_TRAINING_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_TRAINING_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getSpecialtyOrSystemHC = (param) => dispatch => {
    dispatch({ type: GET_SPECIALTYORSYSTEM_REQUEST });
    ApiService.getSpecialtyOrSystemHC(param).then(
        response => {
            dispatch({
                type: GET_SPECIALTYORSYSTEM_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_SPECIALTYORSYSTEM_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getCommunicationProgramHC = (param) => dispatch => {
    dispatch({ type: GET_COMMUNICATIONPROGRAM_REQUEST });
    ApiService.getCommunicationProgramHC(param).then(
        response => {
            dispatch({
                type: GET_COMMUNICATIONPROGRAM_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_COMMUNICATIONPROGRAM_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getProcedureMaterialHC = (param) => dispatch => {
    dispatch({ type: GET_PROCEDUREMATERIAL_REQUEST });
    ApiService.getProcedureMaterialHC(param).then(
        response => {
            dispatch({
                type: GET_PROCEDUREMATERIAL_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_PROCEDUREMATERIAL_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const fetchHistoryCampaign = (data) => dispatch => {
    dispatch({ type: FETCH_HISTORYCOMPAIGN_REQUEST });
    ApiService.fetchHistoryCampaign(data).then(
        response => {
            dispatch({
                type: FETCH_HISTORYCOMPAIGN_SUCCESS,
                payload: response.listData,
                current: (data.offset / data.limit) + 1
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: FETCH_HISTORYCOMPAIGN_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}
export const exportXls = (param) => dispatch => {

    dispatch({ type: EXPORT_HISTORYCOMPAIGN_REQUEST });
    ApiService.exportHistoryCampaign(param).then(
        result => {
            const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            downloadFile(blob, "ReporteHistoricoCampaña.xlsx");

            dispatch({ type: EXPORT_HISTORYCOMPAIGN_SUCCESS });
        }
    ).catch(
        (error) => dispatch({ type: EXPORT_HISTORYCOMPAIGN_FAILURE, payload: error.message })
    )
}

export const clear = () => ({
    type: CLEAR_REDUCER
});

export const clearHistoryCampaign = () => ({
    type: CLEAR_HISTORYCAMPAING
});

export const saveFilter = (filter) => ({
    type: SAVE_FILTER,
    payload: filter
});

export const savePagination = (pagination) => ({
    type: SAVE_PAGINATION,
    payload: pagination
});

const downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
};